import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import ru from '@angular/common/locales/ru';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { ru as ruFns } from 'date-fns/locale';
import {
  NZ_DATE_CONFIG,
  NZ_DATE_LOCALE,
  NZ_I18N,
  ru_RU,
} from 'ng-zorro-antd/i18n';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { AuthModule } from './auth/auth.module';
import { InitAuthProvider } from './auth/auth.providers';
import { tokenGetter } from './auth/auth.utils';
import { GraphQLModule } from './graphql/graphql.module';
import { LayoutComponent } from './layout/layout.component';
import { SharedModule } from './shared/shared.module';
import { StateModule } from './shared/state.module';

registerLocaleData(ru);

@NgModule({
  declarations: [AppComponent, LayoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    GraphQLModule,
    AuthModule,

    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        // allowedDomains: ['localhost'],
      },
    }),

    SharedModule,
    StateModule,
  ],
  providers: [
    InitAuthProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: NZ_I18N, useValue: ru_RU },
    { provide: NZ_DATE_LOCALE, useValue: ruFns },
    {
      provide: NZ_DATE_CONFIG,
      useValue: {
        firstDayOfWeek: 1,
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
